import Container, { Service } from 'typedi';
import {
    IAuthenticationResult,
    IAutoLoginResponseModel,
    IMigrationAutoLoginModel,
    IAuthenticationService,
    IExecuteWithAnalyticsResult,
} from '../models';
import { AuthenticationFlowType } from '../enums';
import { MigrationAutoLoginDataBuilderService } from './migration-autologindata.builder.service';
import { AuthenticationService } from './authentication.service';

@Service()
export class MigrationAuthenticationService {
    private _authenticationService?: IAuthenticationService;
    private readonly _migrationAutoLoginDataBuilder: MigrationAutoLoginDataBuilderService;

    constructor() {
        this._migrationAutoLoginDataBuilder = Container.get(MigrationAutoLoginDataBuilderService);
        this._authenticationService = Container.get(AuthenticationService);
    }

    public migrationAutoLogin = async (
        data: any,
    ): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
        const loginResult: IExecuteWithAnalyticsResult<IAutoLoginResponseModel> =
            await this._authenticationService.executeWithAnalytics(
                AuthenticationFlowType.Migration,
                async (): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
                    const autoLoginData: IMigrationAutoLoginModel =
                        await this._migrationAutoLoginDataBuilder.Build(data);
                    const result: IAuthenticationResult<IAutoLoginResponseModel> =
                        await this._authenticationService.migrationAutoLogin(autoLoginData);
                    const { response, errorResponse } = result;

                    if (response?.Response?.BearerToken)
                        await this._authenticationService.continuePostLoginActions(response);

                    return result;
                },
                true,
            );
        await this._authenticationService.startOfferingAuthentication(loginResult);
        return loginResult?.result;
    };
}
